import ViewRetailPrescription from "../../../../components/@documents/retail_prescriptions/ViewRetailPrescription";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function RetailPrescriptionViewPage() {

    return (
        <ViewRetailPrescription 
            routeType={routeTypes.retail}
        />
    )
}